import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mask',
  standalone: false
})
export class MaskPipe implements PipeTransform {
  public transform(
    value: string | null | undefined,
    showMask: boolean
  ): string {
    if (!value) {
      return '';
    }
    if (showMask && value.length > 0) {
      let result: string = '';
      for (let i = 0; i < value.length - 2; ++i) {
        result += '*';
      }
      return value.substr(0, 2) + result;
    }
    return value;
  }
}
